import { render, staticRenderFns } from "./vendor-details.vue?vue&type=template&id=f4f32304&scoped=true&"
import script from "./vendor-details.vue?vue&type=script&lang=js&"
export * from "./vendor-details.vue?vue&type=script&lang=js&"
import style0 from "./vendor-details.vue?vue&type=style&index=0&id=f4f32304&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f32304",
  null
  
)

export default component.exports